import axios from "../utils/axios";

export class TillService {
  getAllTills(params?: { page?: number; limit?: number }) {
    return axios.get(`/till`, { params });
  }
  getTillData(id: number) {
    return axios.get(`/till/${id}`);
  }
  createTill() {
    return axios.post(`/till`);
  }
  exportTills() {
    return axios.get(`/till/export/csv`, {
      responseType: "text",
    });
  }
  payWithStripe(patientId: number, dispenseId: number) {
    return axios.post(`/till/${patientId}/dispense/${dispenseId}/pay`);
  }
  recordPayment(patientId: number, dispenseId: number, data: { amount: number; paymentMethod: string; paymentDate?: string }) {
    return axios.post(`/till/${patientId}/dispense/${dispenseId}/record-payment`, data);
  }
  payFromWallet(patientId: string | number, dispenseId: number) {
    return axios.post(
      `/till/${patientId}/dispense/${dispenseId}/pay-from-wallet`,
    );
  }
  refundDispenseTill(
    patientId: string | number,
    dispenseId: number,
    data: { reason: string; mode: "refund" | "wallet" },
  ) {
    return axios.post(
      `/till/${patientId}/dispense/${dispenseId}/refund`,
      data,
    );
  }
  verifyPayment(session_id: string) {
    return axios.post(`/till/verify-payment`, { session_id });
  }
}
